module.exports = __webpack_public_path__ + "static/media/c-news.c70fc943.png";